import { Text } from '@primer/react';
import CustomVideoPlayer from "../../../../src/components/custom-video-player";
import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  Text,
  CustomVideoPlayer,
  ComponentLayout,
  React
};